import { Link } from "react-router-dom";
import { ScrollReveal } from "@/hooks/useScrollReveal";
import { CATALOG_URL } from "@/mocks/site-config";
import Watermark from "@/components/base/Watermark";

export default function FinalCTA() {
  return (
    <section className="min-h-[60svh] flex items-center bg-primary-100/50">
      <Watermark />
      <div className="mx-auto px-6 md:px-10 py-20 md:py-28 max-w-[1120px] w-full">
        <ScrollReveal>
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-5">
              從一個主題，開始下一段閱讀
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-10 leading-relaxed">
              無論你是剛開始接觸一個新領域，還是想深入探索特定主題，崧燁文化事業有限公司的出版品都能為你提供閱讀路徑。
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
              <Link
                to="/about"
                className="bg-accent-500 hover:bg-accent-600 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-2"
              >
                品牌介紹 <i className="ri-building-2-line text-sm"></i>
              </Link>
              <Link
                to="/stores"
                className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2"
              >
                合作通路 <i className="ri-store-2-line text-sm"></i>
              </Link>
              <a
                href={CATALOG_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="border border-foreground-300 hover:border-foreground-500 text-foreground-800 px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground-400 focus-visible:ring-offset-2"
              >
                前往書籍資料庫 <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>

            <div className="flex items-center justify-center gap-6">
              <Link
                to="/faq"
                className="text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
              >
                常見問題
              </Link>
              <a
                href="https://sonbook.net/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-1"
              >
                認識崧博出版 <i className="ri-external-link-line text-xs"></i>
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}